import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import img from '../../Images/icons/avatar.png';
import { useTheme } from "../BrandColors/Context/ThemeContext";

import HarryCasual from '../../Images/AvatarImages/harry casual 1.png';
import HarryBusiness from '../../Images/AvatarImages/harry bussiness 2.png';
import HarryYouthful from '../../Images/AvatarImages/harry youthfull 3.png';
import JeffBusiness from '../../Images/AvatarImages/jeff business 4.png';
import JeffFormal from '../../Images/AvatarImages/jeff formal 5.png';
import LisaCasualSitting from '../../Images/AvatarImages/lisa 6.png';
import LoriCasual from '../../Images/AvatarImages/lori casual 7.png';
import LoriGraceful from '../../Images/AvatarImages/lori graceful 8.png';
import LoriFormal from '../../Images/AvatarImages/lori formal 9.png';
import MegFormal from '../../Images/AvatarImages/mag formal 10.png';
import MegCasual from '../../Images/AvatarImages/mag casual 11.png';

const AvatarSelectionForm = () => {
  const [selectedImage, setSelectedImage] = useState(['Harry', 'casual', 'male']);
  const [selectedImageIndex, setSelectedImageIndex] = useState(1);
  const [voiceOption, setVoiceOption] = useState("");
  const [agentName, setAgentName] = useState("");
  const [prompt, setPrompt] = useState("");
  const [script, setScript] = useState("");
  const [carouselIndex, setCarouselIndex] = useState(0);
  const navigate = useNavigate();
  const theme = useTheme() || "#3b82f6";

  const imageButtons = [
    { id: 1, src: HarryBusiness, value: ["Harry", "business", "male"] },
    { id: 2, src: HarryCasual, value: ["Harry", "casual", "male"] },
    { id: 3, src: HarryYouthful, value: ["Harry", "youthful", "male"] },
    { id: 4, src: JeffBusiness, value: ["Jeff", "business", "male"] },
    { id: 5, src: JeffFormal, value: ["Jeff", "formal", "male"] },
    { id: 6, src: LisaCasualSitting, value: ["Lisa", "casual-sitting", "female"] },
    { id: 7, src: LoriCasual, value: ["Lori", "casual", "female"] },
    { id: 8, src: LoriGraceful, value: ["Lori", "graceful", "female"] },
    { id: 9, src: LoriFormal, value: ["Lori", "formal", "female"] },
    { id: 10, src: MegFormal, value: ["Meg", "formal", "female"] },
    { id: 11, src: MegCasual, value: ["Meg", "casual", "female"] },
  ];

  const voiceOptions = {
    male: [
      { value: "en-US-AndrewMultilingualNeural", label: "Andrew" },
      { value: "en-US-BrianMultilingualNeural", label: "Brian" },
    ],
    female: [
      { value: "en-US-AvaMultilingualNeural", label: "Ava" },
      { value: "en-US-EmmaMultilingualNeural", label: "Emma" },
    ],
  };

  const avatarsPerPage = 3;

  const handleImageClick = (value, index) => {
    setSelectedImage(value);
    setSelectedImageIndex(index);
    setAgentName(value[0]);
    setVoiceOption("");
    const newCarouselIndex = Math.max(
      0,
      Math.min(index - 1, imageButtons.length - avatarsPerPage)
    );
    setCarouselIndex(newCarouselIndex);
  };

  const handleVoiceChange = (e) => {
    setVoiceOption(e.target.value);
  };

  const handleNext = () => {
    if (!selectedImage || !voiceOption) {
      alert("Please select both an avatar and a voice.");
      return;
    }
    const formData = { selectedImage, voiceOption, agentName, prompt, script };
    navigate("/avatar-playground", { state: formData });
  };

  const handlePrevCarousel = () => {
    setSelectedImageIndex((prev) => {
      const newIndex = Math.max(prev - 1, 0);
      setSelectedImage(imageButtons[newIndex].value);
      setAgentName(imageButtons[newIndex].value[0]);
      setVoiceOption("");

      const newCarouselIndex = Math.max(
        0,
        Math.min(newIndex - 1, imageButtons.length - avatarsPerPage)
      );
      setCarouselIndex(newCarouselIndex);
      return newIndex;
    });
  };

  const handleNextCarousel = () => {
    setSelectedImageIndex((prev) => {
      const newIndex = Math.min(prev + 1, imageButtons.length - 1);
      setSelectedImage(imageButtons[newIndex].value);
      setAgentName(imageButtons[newIndex].value[0]);
      setVoiceOption("");
   
      const newCarouselIndex = Math.max(
        0,
        Math.min(newIndex - 1, imageButtons.length - avatarsPerPage)
      );
      setCarouselIndex(newCarouselIndex);
      return newIndex;
    });
  };

  const selectedGender = selectedImage?.[2] || "";
  const filteredVoiceOptions = voiceOptions[selectedGender] || [];

  const visibleAvatars = imageButtons.slice(
    carouselIndex,
    carouselIndex + avatarsPerPage
  );

  return (
    <div className="w-full flex flex-col gap-6 animate-fade-in-up">
      <div className="glass-panel w-full p-8 mt-8">
        
        <header className="mb-8 border-b border-blue-200/50 pb-4">
          <h2 className="text-2xl font-bold text-white">Avatar Selection</h2>
          <p className="text-sm text-slate-600 mt-1">Configure your digital agent's appearance and voice.</p>
        </header>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          
          {/* Avatar Preview Section */}
          <section className="flex flex-col items-center">
            <div className="w-full max-w-sm aspect-[4/5] rounded-2xl overflow-hidden glass-card p-4 border border-blue-200/50 flex items-center justify-center bg-white/50 shadow-2xl relative mb-6">
              {selectedImage ? (
                <img
                  src={
                    imageButtons.find(
                      (btn) =>
                        btn.value[0] === selectedImage[0] &&
                        btn.value[1] === selectedImage[1]
                    )?.src || img
                  }
                  alt="Selected Avatar"
                  className="w-full h-full object-contain filter drop-shadow-2xl"
                />
              ) : (
                <div className="text-slate-500 font-medium flex flex-col items-center gap-2">
                  <div className="w-16 h-16 border-2 border-dashed border-slate-600 rounded-full flex items-center justify-center mb-2">
                    ?
                  </div>
                  Select an Avatar
                </div>
              )}
            </div>
            
            <div className="flex items-center gap-4 w-full justify-center">
              <button
                onClick={handlePrevCarousel}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white border border-blue-200 text-slate-700 hover:bg-blue-100 hover:text-white disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                disabled={selectedImageIndex <= 0}
                aria-label="Previous avatars"
              >
                &lt;
              </button>
              
              <div className="flex gap-4 overflow-hidden">
                {visibleAvatars.map((button, index) => {
                  const globalIndex = carouselIndex + index;
                  const isSelected =
                    selectedImage &&
                    button.value[0] === selectedImage[0] &&
                    button.value[1] === selectedImage[1];
                  return (
                    <button
                      key={button.id}
                      onClick={() => handleImageClick(button.value, globalIndex)}
                      className={`w-20 h-24 rounded-xl overflow-hidden border-2 transition-all transform hover:scale-105 active:scale-95 bg-white ${
                        isSelected ? "border-solid shadow-[0_0_15px_rgba(var(--theme-color-rgb),0.5)]" : "border-transparent opacity-70 hover:opacity-100"
                      }`}
                      style={isSelected ? { borderColor: theme, boxShadow: `0 0 15px ${theme}40` } : {}}
                      aria-label={`Select ${button.value[0]} ${button.value[1]} avatar`}
                    >
                      <img
                        src={button.src}
                        alt={`${button.value[0]} ${button.value[1]}`}
                        className="w-full h-full object-cover"
                      />
                    </button>
                  );
                })}
              </div>
              
              <button
                onClick={handleNextCarousel}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white border border-blue-200 text-slate-700 hover:bg-blue-100 hover:text-white disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                disabled={selectedImageIndex >= imageButtons.length - 1}
                aria-label="Next avatars"
              >
                &gt;
              </button>
            </div>
          </section>

          {/* Form Section */}
          <section className="flex flex-col gap-6">
            
            <div className="glass-card p-6 border border-blue-200/50 rounded-xl space-y-5">
              <h3 className="text-lg font-semibold text-white mb-4 border-b border-blue-200/50 pb-2">Agent Details</h3>
              
              <div className="flex flex-col gap-1.5">
                <label htmlFor="agentName" className="text-sm font-medium text-slate-700">Agent Name</label>
                <input
                  type="text"
                  id="agentName"
                  className="input-field opacity-80 cursor-not-allowed bg-blue-50"
                  value={agentName}
                  readOnly
                />
              </div>
              
              <div className="flex flex-col gap-1.5">
                <label htmlFor="language" className="text-sm font-medium text-slate-700">Language</label>
                <select id="language" className="input-field" defaultValue="en">
                  <option value="en" className="bg-blue-50">English</option>
                  <option value="es" className="bg-blue-50">Spanish</option>
                </select>
              </div>
              
              <div className="flex flex-col gap-1.5">
                <label htmlFor="voiceSelect" className="text-sm font-medium text-slate-700">Agent Voice</label>
                <select
                  id="voiceSelect"
                  value={voiceOption}
                  onChange={handleVoiceChange}
                  className="input-field"
                  disabled={!selectedImage}
                >
                  <option value="" className="bg-blue-50">Select a voice</option>
                  {filteredVoiceOptions.map((voice) => (
                    <option key={voice.value} value={voice.value} className="bg-blue-50">
                      {voice.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="glass-card p-6 border border-blue-200/50 rounded-xl space-y-5 flex-grow flex flex-col">
              <h3 className="text-lg font-semibold text-white mb-2 border-b border-blue-200/50 pb-2">Knowledge Base</h3>
              
              <div className="flex flex-col gap-1.5 flex-grow">
                <label htmlFor="agentPrompt" className="text-sm font-medium text-slate-700">System Prompt</label>
                <textarea
                  id="agentPrompt"
                  className="input-field resize-none h-24 font-mono text-sm"
                  placeholder="Enter system prompt guidelines..."
                  value={prompt}
                  onChange={(e) => setPrompt(e.target.value)}
                />
              </div>
              
              <div className="flex flex-col gap-1.5 flex-grow">
                <label htmlFor="agentScript" className="text-sm font-medium text-slate-700">Initial Script (Optional)</label>
                <textarea
                  id="agentScript"
                  className="input-field resize-none h-24"
                  placeholder="Enter introductory script..."
                  value={script}
                  onChange={(e) => setScript(e.target.value)}
                />
              </div>
            </div>

          </section>
        </div>
        
        <footer className="mt-10 pt-6 border-t border-blue-200/50 flex justify-end">
          <button
            onClick={handleNext}
            className="px-8 py-3 rounded-lg font-semibold text-white shadow-lg transition-transform hover:-translate-y-0.5 active:translate-y-0 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
            style={{ backgroundColor: theme }}
            disabled={!selectedImage || !voiceOption}
          >
            Deploy Avatar
          </button>
        </footer>
      </div>
    </div>
  );
};

export default AvatarSelectionForm;